/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdmissionsBoardReferralAssignmentsInner } from './AdmissionsBoardReferralAssignmentsInner';
import {
    AdmissionsBoardReferralAssignmentsInnerFromJSON,
    AdmissionsBoardReferralAssignmentsInnerFromJSONTyped,
    AdmissionsBoardReferralAssignmentsInnerToJSON,
    AdmissionsBoardReferralAssignmentsInnerToJSONTyped,
} from './AdmissionsBoardReferralAssignmentsInner';
import type { UpdateLeadCareAttributes200ResponseDataInner } from './UpdateLeadCareAttributes200ResponseDataInner';
import {
    UpdateLeadCareAttributes200ResponseDataInnerFromJSON,
    UpdateLeadCareAttributes200ResponseDataInnerFromJSONTyped,
    UpdateLeadCareAttributes200ResponseDataInnerToJSON,
    UpdateLeadCareAttributes200ResponseDataInnerToJSONTyped,
} from './UpdateLeadCareAttributes200ResponseDataInner';
import type { InsurancePayor } from './InsurancePayor';
import {
    InsurancePayorFromJSON,
    InsurancePayorFromJSONTyped,
    InsurancePayorToJSON,
    InsurancePayorToJSONTyped,
} from './InsurancePayor';
import type { AdmissionsBoardSource } from './AdmissionsBoardSource';
import {
    AdmissionsBoardSourceFromJSON,
    AdmissionsBoardSourceFromJSONTyped,
    AdmissionsBoardSourceToJSON,
    AdmissionsBoardSourceToJSONTyped,
} from './AdmissionsBoardSource';
import type { AdmissionStatusCode } from './AdmissionStatusCode';
import {
    AdmissionStatusCodeFromJSON,
    AdmissionStatusCodeFromJSONTyped,
    AdmissionStatusCodeToJSON,
    AdmissionStatusCodeToJSONTyped,
} from './AdmissionStatusCode';

/**
 * 
 * @export
 * @interface AdmissionsBoardReferral
 */
export interface AdmissionsBoardReferral {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * ISO 8601 timestamp.
     */
    lead_received_date: string;
    /**
     * 
     */
    admission_status_code: AdmissionStatusCode;
    /**
     * Display name of the admission status.
     */
    admission_status: string;
    /**
     * Estimated discharge date, YYYY-MM-DD.
     */
    source_discharge_date: string | null;
    /**
     * Scheduled Start (Scheduled SOC or Scheduled Admission) from the current admission status row, YYYY-MM-DD.
     */
    scheduled_start_date: string | null;
    /**
     * 
     */
    has_previous_stay_in_facility: boolean;
    /**
     * The lead's current active payer, preferring Primary, then Secondary, then Tertiary coverage.
     */
    active_payer: InsurancePayor | null;
    /**
     * 
     */
    source: AdmissionsBoardSource | null;
    /**
     * 
     */
    service_address: string | null;
    /**
     * 
     */
    assignments: Array<AdmissionsBoardReferralAssignmentsInner>;
    /**
     * 
     */
    care_attributes: Array<UpdateLeadCareAttributes200ResponseDataInner>;
}



/**
 * Check if a given object implements the AdmissionsBoardReferral interface.
 */
export function instanceOfAdmissionsBoardReferral(value: object): value is AdmissionsBoardReferral {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('lead_received_date' in value) || value['lead_received_date'] === undefined) return false;
    if (!('admission_status_code' in value) || value['admission_status_code'] === undefined) return false;
    if (!('admission_status' in value) || value['admission_status'] === undefined) return false;
    if (!('source_discharge_date' in value) || value['source_discharge_date'] === undefined) return false;
    if (!('scheduled_start_date' in value) || value['scheduled_start_date'] === undefined) return false;
    if (!('has_previous_stay_in_facility' in value) || value['has_previous_stay_in_facility'] === undefined) return false;
    if (!('active_payer' in value) || value['active_payer'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('service_address' in value) || value['service_address'] === undefined) return false;
    if (!('assignments' in value) || value['assignments'] === undefined) return false;
    if (!('care_attributes' in value) || value['care_attributes'] === undefined) return false;
    return true;
}

export function AdmissionsBoardReferralFromJSON(json: any): AdmissionsBoardReferral {
    return AdmissionsBoardReferralFromJSONTyped(json, false);
}

export function AdmissionsBoardReferralFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionsBoardReferral {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'lead_received_date': json['lead_received_date'],
        'admission_status_code': AdmissionStatusCodeFromJSON(json['admission_status_code']),
        'admission_status': json['admission_status'],
        'source_discharge_date': json['source_discharge_date'],
        'scheduled_start_date': json['scheduled_start_date'],
        'has_previous_stay_in_facility': json['has_previous_stay_in_facility'],
        'active_payer': InsurancePayorFromJSON(json['active_payer']),
        'source': AdmissionsBoardSourceFromJSON(json['source']),
        'service_address': json['service_address'],
        'assignments': ((json['assignments'] as Array<any>).map(AdmissionsBoardReferralAssignmentsInnerFromJSON)),
        'care_attributes': ((json['care_attributes'] as Array<any>).map(UpdateLeadCareAttributes200ResponseDataInnerFromJSON)),
    };
}

export function AdmissionsBoardReferralToJSON(json: any): AdmissionsBoardReferral {
    return AdmissionsBoardReferralToJSONTyped(json, false);
}

export function AdmissionsBoardReferralToJSONTyped(value?: AdmissionsBoardReferral | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'lead_received_date': value['lead_received_date'],
        'admission_status_code': AdmissionStatusCodeToJSON(value['admission_status_code']),
        'admission_status': value['admission_status'],
        'source_discharge_date': value['source_discharge_date'],
        'scheduled_start_date': value['scheduled_start_date'],
        'has_previous_stay_in_facility': value['has_previous_stay_in_facility'],
        'active_payer': InsurancePayorToJSON(value['active_payer']),
        'source': AdmissionsBoardSourceToJSON(value['source']),
        'service_address': value['service_address'],
        'assignments': ((value['assignments'] as Array<any>).map(AdmissionsBoardReferralAssignmentsInnerToJSON)),
        'care_attributes': ((value['care_attributes'] as Array<any>).map(UpdateLeadCareAttributes200ResponseDataInnerToJSON)),
    };
}

